import { Author, CommentEntry, CommentEntryComponent } from '@lib/comment';
import { IInvoiceHistoryComment } from '../../detail/types/IStandaloneInvoiceDetail';

export class InvoiceCommentEntry extends CommentEntry {
    constructor(dto: IInvoiceHistoryComment, currentlyLoggedInUserId: string) {
        super(
            dto.comment,
            CommentEntryComponent,
            dto.timestamp,
            currentlyLoggedInUserId,
            dto.author ? new Author(dto.author.id, '', dto.author.name) : undefined,
            dto.superUser ? new Author(dto.superUser.id, '', dto.superUser.name) : undefined,
            dto.files,
            dto.isInternal,
            dto.id,
        );
    }
}
